import { render, staticRenderFns } from "./graph-data-value.vue?vue&type=template&id=099be01d&scoped=true"
import script from "./graph-data-value.vue?vue&type=script&lang=js"
export * from "./graph-data-value.vue?vue&type=script&lang=js"
import style0 from "./graph-data-value.vue?vue&type=style&index=0&id=099be01d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099be01d",
  null
  
)

export default component.exports